import { RouterConfig } from '@angular/router';
import { TAFBookComponent } from './taf-book.component';
import { TAFBookS1Component } from './taf-book-s1/taf-book-s1.component';
import { TAFBookGraphS1Component } from './taf-book-graph-s1/taf-book-graph-s1.component';
import { TAFBookS2Component } from './taf-book-s2/taf-book-s2.component';
import { TAFBookS3Component } from './taf-book-s3/taf-book-s3.component';
import { TAFBookB1Component } from './taf-book-b1/taf-book-b1.component';
import { TAFBookB2Component } from './taf-book-b2/taf-book-b2.component';
import { TAFBookB3Component } from './taf-book-b3/taf-book-b3.component';
import { TAFBookB4Component } from './taf-book-b4/taf-book-b4.component';
import { TAFBookB5Component } from './taf-book-b5/taf-book-b5.component';
import { AuthGuard } from '../../authentication/auth-guard.service';

export const TAFBookRoutes: RouterConfig = [
  { path: 'taf-book', component: TAFBookComponent, canActivate: [AuthGuard] },
  { path: 'taf-book-s1', component: TAFBookS1Component},
  { path: 'taf-book-graph-s1', component: TAFBookGraphS1Component},
  { path: 'taf-book-s2', component: TAFBookS2Component},
  { path: 'taf-book-s3', component: TAFBookS3Component},
  { path: 'taf-book-b1', component: TAFBookB1Component},
  { path: 'taf-book-b2', component: TAFBookB2Component},
  { path: 'taf-book-b3', component: TAFBookB3Component},
  { path: 'taf-book-b4', component: TAFBookB4Component},
  { path: 'taf-book-b5', component: TAFBookB5Component},
  //all tafbook routes here
];




/** WEBPACK FOOTER **
 ** ./app/system-management/tafbooks/taf-book.routes.ts
 **/